import { makeAutoObservable } from "mobx";
export class OperationsStore {
    operations = [];
    pageNumber = 0;
    allEntriesLoaded = false;
    selectedOperation = null;
    registrationId = " "; // initial value, so empty string filter also triggers data fetching
    constructor() {
        makeAutoObservable(this, {
            setOperations: true,
            setSelectedOperation: true,
            appendOperations: true
        });
    }
    // first batch
    setOperations(ops, allEntriesLoaded, regId) {
        this.operations = ops;
        this.registrationId = regId;
        this.pageNumber = 0;
        this.allEntriesLoaded = allEntriesLoaded;
    }
    // paginated batch
    appendOperations(ops, allEntriesLoaded, pageNumber) {
        this.operations.push(...ops);
        this.pageNumber = pageNumber;
        this.allEntriesLoaded = allEntriesLoaded;
    }
    setSelectedOperation(op) {
        this.selectedOperation = op;
    }
}
